import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const dockSuggestions = {
  firestorePath: '/dock-suggestions',
  firestoreRefType: 'collection',
  moduleName: 'dockSuggestions',
  statePropName: 'dockSuggestions',
  namespaced: true,
  sync: {
    debounceTimerMs: 1
  },

  state, getters, actions, mutations
}

export default dockSuggestions